import { Facets, SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class SetPreSelectedFilters implements SearchMutation {

  mutations = {
    [SEARCH_MUTATIONS_KEYS.setPreselectedFilters]: (searchState: SearchState, preselectedFilters: Facets) => {
      searchState.preSelectedFilters = preselectedFilters;
    }
  };
}
